// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "js/" + "js/lobby" + "." + "831ca78c" + ".js"; };